import { useState } from 'react';
import { reportType } from 'components/pages/contacts/components/ExportEOYReportAlert';

enum ContactsModal {
    None,
    ExportEOYReports,
    ExportsHistory,
    ExportSuccess,
    ImportTemplate,
}

const useContactsModalState = (defaultModal?: ContactsModal) => {
    const [exportReportType, setExportReportType] = useState<reportType>('zip');
    const [openModal, setOpenModal] = useState(defaultModal ?? ContactsModal.None);

    return {
        openModal,
        setOpenModal,
        exportReportType,
        setExportReportType,
    };
};

export { useContactsModalState, ContactsModal };
